/** Preserves a trailing decimal for incremental input and truncates excess fractional digits. */
export const sanitizeDecimalInput = (raw: string, maximumFractionDigits?: number): string => {
  const [whole, ...fractions] = raw.replace(/[^\d.]/g, '').split('.');
  const fraction = fractions.join('').slice(0, maximumFractionDigits);

  return fractions.length > 0 ? `${whole}.${fraction}` : whole;
};

/** Truncate at commit, not while editing: stripping the separator per keystroke reads `1.5` as `15`. */
export const normalizeCount = (raw: string): string => {
  const [whole] = sanitizeDecimalInput(raw).split('.');

  return whole;
};
